import store from '@/Store'
import { downloadConvertBase64Url } from '@/utils/Download'
import { formatFileForSendWidget } from '@/utils/utils'
import mime from 'mime'

const setupApp = store.state.SetupApp
const acionaFuncionalidade = async (req) => {
  let data = {}
  if (req.nomeIntegracao !== '') {
    let base64 = ''
    const response = await setupApp.apiFuncionalidade[req.nomeIntegracao]({
      payload: req.integracao.payload,
      loading: true,
      handlerErrorIgnore: true
    })
    if (response.data.url && !response.data.base64) {
      base64 = await downloadConvertBase64Url({ url: response.data.url })
    } else {
      base64 = `data:application/pdf;base64,${response.data.base64}`
    }

    const arquivo = formatFileForSendWidget(base64)
    data = {
      type: 'arquivo',
      message: `${req.data.tituloWidget}.${mime.getExtension(arquivo.mimeType)}`,
      file: arquivo.file
    }
  } else {
    data = {
      type: 'texto',
      message: req.data.textoPINSS
    }
  }

  return { status: true, data, message: 'sucesso' }
}

export {
  acionaFuncionalidade
}
